import styled from "styled-components";

export const SiteSetupWrapper = styled.div`
  min-width: 266px;
  position: relative;
  .action-zone-sub-side-nav {
    position: absolute;
    right: -270px;
    top: 12px;
    overflow: auto;
    height: calc(100vh - 150px);
    overflow-x: hidden;
  }
`;
